// AWS Configuration - uses default AWS credentials
export const AWS_CONFIG = {
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1'
};

// Available Bedrock models for translation
export const BEDROCK_MODELS = {
  // Anthropic Claude Models
  'claude-3-haiku': {
    modelId: 'anthropic.claude-3-haiku-20240307-v1:0',
    name: 'Claude 3 Haiku',
    provider: 'Anthropic',
    description: 'Fast and cost-effective, good for simple translations',
    maxTokens: 4096,
    costTier: 'Low',
    inputCostPer1K: 0.00025,
    outputCostPer1K: 0.00125
  },
  'claude-3-sonnet': {
    modelId: 'anthropic.claude-3-sonnet-20240229-v1:0',
    name: 'Claude 3 Sonnet',
    provider: 'Anthropic',
    description: 'Balanced performance and cost, better for complex translations',
    maxTokens: 4096,
    costTier: 'Medium',
    inputCostPer1K: 0.003,
    outputCostPer1K: 0.015
  },
  'claude-3-opus': {
    modelId: 'anthropic.claude-3-opus-20240229-v1:0',
    name: 'Claude 3 Opus',
    provider: 'Anthropic',
    description: 'Highest quality, best for nuanced translations',
    maxTokens: 4096,
    costTier: 'High',
    inputCostPer1K: 0.015,
    outputCostPer1K: 0.075
  },
  'claude-3-5-sonnet': {
    modelId: 'anthropic.claude-3-5-sonnet-20240620-v1:0',
    name: 'Claude 3.5 Sonnet',
    provider: 'Anthropic',
    description: 'Latest model, excellent balance of speed and quality',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.003,
    outputCostPer1K: 0.015
  },
  'claude-3-5-sonnet-v2': {
    modelId: 'anthropic.claude-3-5-sonnet-20241022-v2:0',
    name: 'Claude 3.5 Sonnet v2',
    provider: 'Anthropic',
    description: 'Updated Claude 3.5 Sonnet with improved capabilities',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.003,
    outputCostPer1K: 0.015
  },
  'claude-3-7-sonnet': {
    modelId: 'anthropic.claude-3-7-sonnet-20250219-v1:0',
    name: 'Claude 3.7 Sonnet',
    provider: 'Anthropic',
    description: 'Advanced Claude model with enhanced reasoning',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.003,
    outputCostPer1K: 0.015
  },
  'claude-3-5-haiku': {
    modelId: 'anthropic.claude-3-5-haiku-20241022-v1:0',
    name: 'Claude 3.5 Haiku',
    provider: 'Anthropic',
    description: 'Faster Claude 3.5 model for quick translations',
    maxTokens: 8192,
    costTier: 'Low',
    inputCostPer1K: 0.0008,
    outputCostPer1K: 0.004
  },
  'claude-sonnet-4': {
    modelId: 'anthropic.claude-sonnet-4-20250514-v1:0',
    name: 'Claude Sonnet 4',
    provider: 'Anthropic',
    description: 'Next-generation Claude 4 model',
    maxTokens: 8192,
    costTier: 'High',
    inputCostPer1K: 0.015,
    outputCostPer1K: 0.075
  },
  'claude-opus-4': {
    modelId: 'anthropic.claude-opus-4-20250514-v1:0',
    name: 'Claude Opus 4',
    provider: 'Anthropic',
    description: 'Premium Claude 4 model for highest quality',
    maxTokens: 8192,
    costTier: 'Premium',
    inputCostPer1K: 0.03,
    outputCostPer1K: 0.15
  },
  'claude-opus-4-1': {
    modelId: 'anthropic.claude-opus-4-1-20250805-v1:0',
    name: 'Claude Opus 4.1',
    provider: 'Anthropic',
    description: 'Latest Claude Opus with enhanced capabilities',
    maxTokens: 8192,
    costTier: 'Premium',
    inputCostPer1K: 0.03,
    outputCostPer1K: 0.15
  },

  // Amazon Nova Models
  'nova-micro': {
    modelId: 'amazon.nova-micro-v1:0',
    name: 'Nova Micro',
    provider: 'Amazon',
    description: 'Ultra-fast and cost-effective for simple translations',
    maxTokens: 8192,
    costTier: 'Ultra Low',
    inputCostPer1K: 0.00035,
    outputCostPer1K: 0.0014
  },
  'nova-lite': {
    modelId: 'amazon.nova-lite-v1:0',
    name: 'Nova Lite',
    provider: 'Amazon',
    description: 'Lightweight model for basic translation tasks',
    maxTokens: 8192,
    costTier: 'Low',
    inputCostPer1K: 0.0006,
    outputCostPer1K: 0.0024
  },
  'nova-pro': {
    modelId: 'amazon.nova-pro-v1:0',
    name: 'Nova Pro',
    provider: 'Amazon',
    description: 'Professional-grade model for complex translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.0008,
    outputCostPer1K: 0.0032
  },
  'nova-premier': {
    modelId: 'amazon.nova-premier-v1:0',
    name: 'Nova Premier',
    provider: 'Amazon',
    description: 'Top-tier Nova model for highest quality translations',
    maxTokens: 8192,
    costTier: 'High',
    inputCostPer1K: 0.003,
    outputCostPer1K: 0.012
  },

  // Amazon Titan Models
  'titan-text': {
    modelId: 'amazon.titan-text-express-v1',
    name: 'Titan Text Express',
    provider: 'Amazon',
    description: 'Amazon\'s text model, good for basic translations',
    maxTokens: 8000,
    costTier: 'Low',
    inputCostPer1K: 0.0008,
    outputCostPer1K: 0.0016
  },
  'titan-text-premier': {
    modelId: 'amazon.titan-text-premier-v1:0',
    name: 'Titan Text Premier',
    provider: 'Amazon',
    description: 'Premium Titan model with enhanced capabilities',
    maxTokens: 8000,
    costTier: 'Medium',
    inputCostPer1K: 0.0005,
    outputCostPer1K: 0.0015
  },
  'titan-text-lite': {
    modelId: 'amazon.titan-text-lite-v1',
    name: 'Titan Text Lite',
    provider: 'Amazon',
    description: 'Lightweight Titan model for simple tasks',
    maxTokens: 4000,
    costTier: 'Ultra Low',
    inputCostPer1K: 0.0003,
    outputCostPer1K: 0.0004
  },
  'titan-text-large': {
    modelId: 'amazon.titan-tg1-large',
    name: 'Titan Text Large',
    provider: 'Amazon',
    description: 'Large Titan model for comprehensive translations',
    maxTokens: 8000,
    costTier: 'Medium',
    inputCostPer1K: 0.0008,
    outputCostPer1K: 0.0016
  },

  // Meta Llama Models
  'llama-3-8b': {
    modelId: 'meta.llama3-8b-instruct-v1:0',
    name: 'Llama 3 8B',
    provider: 'Meta',
    description: 'Efficient Llama 3 model for translations',
    maxTokens: 8192,
    costTier: 'Low',
    inputCostPer1K: 0.0003,
    outputCostPer1K: 0.0006
  },
  'llama-3-70b': {
    modelId: 'meta.llama3-70b-instruct-v1:0',
    name: 'Llama 3 70B',
    provider: 'Meta',
    description: 'Large Llama 3 model for complex translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.00265,
    outputCostPer1K: 0.0035
  },
  'llama-3-1-8b': {
    modelId: 'meta.llama3-1-8b-instruct-v1:0',
    name: 'Llama 3.1 8B',
    provider: 'Meta',
    description: 'Updated Llama 3.1 8B model',
    maxTokens: 8192,
    costTier: 'Low',
    inputCostPer1K: 0.0003,
    outputCostPer1K: 0.0006
  },
  'llama-3-1-70b': {
    modelId: 'meta.llama3-1-70b-instruct-v1:0',
    name: 'Llama 3.1 70B',
    provider: 'Meta',
    description: 'Updated Llama 3.1 70B model',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.00265,
    outputCostPer1K: 0.0035
  },
  'llama-3-2-1b': {
    modelId: 'meta.llama3-2-1b-instruct-v1:0',
    name: 'Llama 3.2 1B',
    provider: 'Meta',
    description: 'Compact Llama 3.2 model',
    maxTokens: 8192,
    costTier: 'Ultra Low',
    inputCostPer1K: 0.0001,
    outputCostPer1K: 0.0002
  },
  'llama-3-2-3b': {
    modelId: 'meta.llama3-2-3b-instruct-v1:0',
    name: 'Llama 3.2 3B',
    provider: 'Meta',
    description: 'Small Llama 3.2 model',
    maxTokens: 8192,
    costTier: 'Ultra Low',
    inputCostPer1K: 0.00015,
    outputCostPer1K: 0.0003
  },
  'llama-3-3-70b': {
    modelId: 'meta.llama3-3-70b-instruct-v1:0',
    name: 'Llama 3.3 70B',
    provider: 'Meta',
    description: 'Latest Llama 3.3 70B model',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.00265,
    outputCostPer1K: 0.0035
  },
  'llama-4-scout': {
    modelId: 'meta.llama4-scout-17b-instruct-v1:0',
    name: 'Llama 4 Scout 17B',
    provider: 'Meta',
    description: 'Next-gen Llama 4 Scout model',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.001,
    outputCostPer1K: 0.002
  },
  'llama-4-maverick': {
    modelId: 'meta.llama4-maverick-17b-instruct-v1:0',
    name: 'Llama 4 Maverick 17B',
    provider: 'Meta',
    description: 'Advanced Llama 4 Maverick model',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.001,
    outputCostPer1K: 0.002
  },

  // Mistral Models
  'mistral-7b': {
    modelId: 'mistral.mistral-7b-instruct-v0:2',
    name: 'Mistral 7B',
    provider: 'Mistral AI',
    description: 'Efficient Mistral model for translations',
    maxTokens: 8192,
    costTier: 'Low',
    inputCostPer1K: 0.00015,
    outputCostPer1K: 0.0002
  },
  'mixtral-8x7b': {
    modelId: 'mistral.mixtral-8x7b-instruct-v0:1',
    name: 'Mixtral 8x7B',
    provider: 'Mistral AI',
    description: 'Mixture of experts model for complex translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.00045,
    outputCostPer1K: 0.0007
  },
  'mistral-large': {
    modelId: 'mistral.mistral-large-2402-v1:0',
    name: 'Mistral Large',
    provider: 'Mistral AI',
    description: 'Large Mistral model for high-quality translations',
    maxTokens: 8192,
    costTier: 'High',
    inputCostPer1K: 0.008,
    outputCostPer1K: 0.024
  },
  'mistral-small': {
    modelId: 'mistral.mistral-small-2402-v1:0',
    name: 'Mistral Small',
    provider: 'Mistral AI',
    description: 'Compact Mistral model for basic translations',
    maxTokens: 8192,
    costTier: 'Low',
    inputCostPer1K: 0.002,
    outputCostPer1K: 0.006
  },

  // Cohere Models
  'command-r': {
    modelId: 'cohere.command-r-v1:0',
    name: 'Command R',
    provider: 'Cohere',
    description: 'Cohere Command R for translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.0005,
    outputCostPer1K: 0.0015
  },
  'command-r-plus': {
    modelId: 'cohere.command-r-plus-v1:0',
    name: 'Command R+',
    provider: 'Cohere',
    description: 'Enhanced Cohere Command R+ model',
    maxTokens: 8192,
    costTier: 'High',
    inputCostPer1K: 0.003,
    outputCostPer1K: 0.015
  },

  // AI21 Models
  'jamba-1-5-large': {
    modelId: 'ai21.jamba-1-5-large-v1:0',
    name: 'Jamba 1.5 Large',
    provider: 'AI21 Labs',
    description: 'Large Jamba model for comprehensive translations',
    maxTokens: 8192,
    costTier: 'High',
    inputCostPer1K: 0.002,
    outputCostPer1K: 0.008
  },
  'jamba-1-5-mini': {
    modelId: 'ai21.jamba-1-5-mini-v1:0',
    name: 'Jamba 1.5 Mini',
    provider: 'AI21 Labs',
    description: 'Compact Jamba model for quick translations',
    maxTokens: 8192,
    costTier: 'Low',
    inputCostPer1K: 0.0002,
    outputCostPer1K: 0.0004
  },

  // DeepSeek Models
  'deepseek-r1': {
    modelId: 'deepseek.r1-v1:0',
    name: 'DeepSeek R1',
    provider: 'DeepSeek',
    description: 'DeepSeek reasoning model for translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.0014,
    outputCostPer1K: 0.0028
  },

  // OpenAI Models (Available in Bedrock)
  'gpt-oss-20b': {
    modelId: 'openai.gpt-oss-20b-1:0',
    name: 'GPT OSS 20B',
    provider: 'OpenAI',
    description: 'OpenAI GPT model for translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.001,
    outputCostPer1K: 0.002
  },
  'gpt-oss-120b': {
    modelId: 'openai.gpt-oss-120b-1:0',
    name: 'GPT OSS 120B',
    provider: 'OpenAI',
    description: 'Large OpenAI GPT model for complex translations',
    maxTokens: 8192,
    costTier: 'High',
    inputCostPer1K: 0.008,
    outputCostPer1K: 0.016
  },

  // Qwen Models
  'qwen3-32b': {
    modelId: 'qwen.qwen3-32b-v1:0',
    name: 'Qwen3 32B',
    provider: 'Qwen',
    description: 'Qwen3 model for multilingual translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.0007,
    outputCostPer1K: 0.0014
  },
  'qwen3-coder-30b': {
    modelId: 'qwen.qwen3-coder-30b-a3b-v1:0',
    name: 'Qwen3 Coder 30B',
    provider: 'Qwen',
    description: 'Qwen3 Coder model optimized for technical translations',
    maxTokens: 8192,
    costTier: 'Medium',
    inputCostPer1K: 0.0007,
    outputCostPer1K: 0.0014
  }
};

// Default model
export const DEFAULT_MODEL = 'claude-3-haiku';

// Supported languages configuration
export const SUPPORTED_LANGUAGES = {
  'auto': { name: 'Auto-detect (Amazon Transcribe)', code: 'auto', flag: '🌐' },
  'en': { name: 'English', code: 'en', flag: '🇺🇸' },
  'th': { name: 'Thai', code: 'th', flag: '🇹🇭' },
  'ar': { name: 'Arabic', code: 'ar', flag: '🇸🇦' },
  'zh': { name: 'Chinese', code: 'zh', flag: '🇨🇳' },
  'ja': { name: 'Japanese', code: 'ja', flag: '🇯🇵' },
  'fr': { name: 'French', code: 'fr', flag: '🇫🇷' },
  'es': { name: 'Spanish', code: 'es', flag: '🇪🇸' }
};

// Language codes for Web Speech API (browser speech recognition)
export const SPEECH_RECOGNITION_LANGUAGE_CODES = {
  'en': 'en-US',
  'th': 'th-TH',
  'ar': 'ar-SA',
  'zh': 'zh-CN',
  'ja': 'ja-JP',
  'fr': 'fr-FR',
  'es': 'es-ES'
};

// Language codes for Amazon Transcribe (if we use it later)
export const TRANSCRIBE_LANGUAGE_CODES = {
  'th': 'th-TH',
  'ar': 'ar-SA',
  'zh': 'zh-CN',
  'ja': 'ja-JP',
  'fr': 'fr-FR',
  'es': 'es-ES',
  'en': 'en-US'
};
